import { render, staticRenderFns } from "./status-ctrl.vue?vue&type=template&id=6fc3af6a&scoped=true"
import script from "./status-ctrl.vue?vue&type=script&lang=js"
export * from "./status-ctrl.vue?vue&type=script&lang=js"
import style0 from "./status-ctrl.vue?vue&type=style&index=0&id=6fc3af6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3af6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
